<template>
  <div class="nl-featured-banner">
    <swiper class="swiper" :options="swiperOption">
      <swiper-slide v-for="(row, index) in rows.slice(0, 5)" :key="index">
        <img v-lazy="row.featured_photo.large.url" :alt="row.name" class="nl-banner-img">
        <div class="nl-info-section row m-0">
          <div class="col-lg-6 d-flex flex-column justify-content-center">
            <div class="general-heading-2">{{ row.name }}, {{ row.street }}</div>
            <div class="p4-proploc pt-2 text-capitalize">
              <div class="d-flex align-items-center justify-content-center mr-2" style="border-radius:50%;width:15px;height:15px;font-size:10px;background:#BC1616;margin-top:1px;flex-shrink: 0;">
                <i class="fas fa-map-marker-alt" style="color:#8A0000;"></i>
              </div>
              <div>{{ row.area }}, {{ row.property_type }}</div>
            </div>
          </div>
          <div class="col-lg-6 px-0 py-2 d-flex align-items-center justify-content-center">
            <a :href="'/new_launches/' + row.slug" class="header-login-btn v3">View</a>
            <a :href="'/new_launches/' + row.slug" class="header-login-btn v2 text-nowrap mw-auto">Contact for details</a>
          </div>
        </div>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

  export default {
    name: "newlaunch-banner",
    components: {
      Swiper,
      SwiperSlide
    },
    props: ['rows'],
    data() {
      return {
        swiperOption: {
          direction: 'horizontal',
          spaceBetween: 5,
          mousewheel: true,
          initialSlide: 0,
          autoplay: {
            delay: 3000,
            stopOnLastSlide: false,
            disableOnInteraction: false,
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
        }
      };
    },
    methods: {
      addComma: function (num) {
        var num_parts = num.toString().split(".");
        num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return num_parts.join(".");
      },
    }
  };
</script>

<style scoped lang='scss'>
  .nl-featured-banner {
    width: 100%;
    height: 500px;

    .swiper {
      height: 100%;
    }

    .nl-info-section {
      background: rgba(28, 28, 28, 0.8);
      position: absolute;
      width: 100%;
      bottom: 0;
      left: 0;
      padding: 20px;
    }

    .nl-banner-img {
      height: 100%;
      width: 100%;
      object-fit: cover;
    }
  }

  @media (max-width: 991px) {
    .nl-featured-banner {
      height: 300px;
    }
  }
</style>